import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { translate, } from '../../../../../utils/util';
import { ENUMS } from '../../../../../utils/constants';
import * as pabReplanningAction from '../../../../../actions/pabReplanningAction';
import Breadcrumbs from '../../../../../components/UI/Breadcrumbs';
import PabReplanningListSupplier from '../../Supplier/PabReplanningListSupplier';

const SmallPartsFilterBySupplier = (props) => {

    const subtitlesSmallPartsFilterBySupplier = () => {
        return [{ icon: "mdi mdi-filter-variant", label: translate('expedition:picking.filterBySupplier') }];
    }

    return (
        <div>
            <Breadcrumbs id="SmallPartsFilter" subtitles={subtitlesSmallPartsFilterBySupplier()} />
            <div className="container-fluid" style={{ marginTop: '40px', }}>
                <PabReplanningListSupplier data={props} />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        filter: state.pabReplanningReducer.filter
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setFilter: (filter) => {
            dispatch(pabReplanningAction.setFilter(filter));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SmallPartsFilterBySupplier)));
